export function rgbToHex([r, g, b]) {
  let color = '000000' + ((r << 16) + (g << 8) + b).toString(16);
  color = color.slice(-6);
  return `#${color}`;
}
